import { Link } from "react-router-dom";
import { ReactSession } from "react-client-session";

const Missing = () => {
  const role = ReactSession.get("role");

  return (
    <article style={{ padding: "100px" }}>
      <h1>Oops!</h1>
      <p>Page Not Found</p>
      <div className="flexGrow">
        {role === "1" ? (
          <Link to="/admin">Go to home page</Link>
        ) : role === "2" ? (
          <Link to="/supervisor">Go to home page</Link>
        ) : role === "3" ? (
          <Link to="/operator">Go to home page</Link>
        ) : (
          <Link to="/">Go to home page</Link>
        )}
      </div>
    </article>
  );
};

export default Missing;
